const aboutMe = `
  Hello my name is Godspower Nathaniel, I'm a frontend developer,
  interested in having my lines of code in a popular opensource repo.
  I love startups, game development and basically everything tech.
  That said, I want to launch a startup that actually solves problems,
  at the same time build my own game. Everything I do is a step to my
  goal
`;

export default aboutMe;
